import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { JobMapWorkspace } from "@/features/map";
import {
	type MapViewSearch,
	mapViewSearchSchema,
} from "@/features/map/lib/map-view-search";
import { jobQueryOptions } from "@/services/job";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/map",
)({
	component: JobWorkspaceMapTab,
	validateSearch: (search): MapViewSearch => mapViewSearchSchema.parse(search),
});

function JobWorkspaceMapTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/map",
	});
	const jobById = useQuery(
		jobQueryOptions.detail(params.jobId, { organizationId: params.orgId }),
	);

	return (
		<JobMapWorkspace
			orgId={params.orgId}
			jobId={params.jobId}
			job={jobById.data}
			isJobPending={jobById.isPending}
		/>
	);
}
